<template>
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
<title>arrow_right_2</title>
<path fill="#444" d="M20.267 13.76l-8.267-7.467c-0.373-0.267-0.853-0.213-1.12 0.16-0.267 0.32-0.213 0.8 0.107 1.12l8.267 7.467c0.32 0.267 0.427 0.587 0.427 0.96s-0.16 0.8-0.427 1.067l-8.267 7.467c-0.107 0.107-0.267 0.267-0.267 0.587 0 0.267 0.107 0.48 0.213 0.64l0.053 0.053h0.107c0.107 0.053 0.267 0.107 0.427 0.107 0.107 0 0.373 0 0.587-0.267l8.267-7.467c0.64-0.64 0.96-1.44 0.96-2.347-0.053-0.747-0.48-1.547-1.067-2.080z"></path>
</svg>
</template>

<script>
export default {
    name: "ArrowRightIcon"
}
</script>


// WEBPACK FOOTER //
// src/icons/ArrowRightIcon.vue